import { Div } from "./ContainerStyled";

export const Container = ({ children }) => {
  return <Div>{children}</Div>;
};
